module.exports = __webpack_public_path__ + "static/img/main.dc21b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/12/main.png
// module id = hP1Y
// module chunks = 1